$(document).on("click", "[data-behavior~=open-lightbox]", function() {
  var target = $("[data-type~= " + $(this).data("target") + "]").first();
  require("../modules/featherlight");

  $.featherlight(target, {
    openSpeed: 150,
    closeSpeed: 150,
  });
});
